module.exports = __webpack_public_path__ + "img/1.42b7e060.png";